<template>
  <v-container class="pa-0">
    <!-- <v-tooltip bottom>
      <template v-slot:activator='{ on, attrs }'>
        <v-btn
          class='mx-2'
          fab
          dark
          small
          v-bind='attrs'
          v-on='on'
          color='yellow'
          :loading='lostInvLoading'
          @click='download'
        >
          <v-icon dark>mdi-package-down</v-icon>
        </v-btn>
      </template>
      <span>Export</span>
    </v-tooltip> -->
    <download-excel
      class="primary--color"
      :fetch="getlostInv"
      worksheet="untitled"
      :title="`Lost Inventory ${storeName}`"
      type="xls"
      :name="`${storeName}_lost_inventory_${new Date().getTime()}.xls`"
      :fields="getFields()"
    >
      <v-btn
        block
        :loading="this.lostInvLoading"
        color="primary"
      >Export</v-btn>
    </download-excel>
    <alert-success
      :toggle-dialog="success"
      title="Import Success"
      message="Data was Exported successfully"
    />
    <alert-error
      :toggle-dialog="error"
      title="Import Error!"
      :message="lostInvErrors"
    />
  </v-container>
</template>
<script>
  import writeExcel from '@/extra-functions/writeExcel.extra'
  import { errorHandler } from '@/extra-functions/store.extra'
  import searchDelay from '@/extra-functions/searchDelay.extra'
  import lostInvRepository from '@/repositories/lost-inventory.repository'
  import { mapState } from 'vuex'

  const errorDelay = searchDelay(100)
  const successDelay = searchDelay(100)
  const { dialog } = require('electron').remote
  const getlostInvDelay = searchDelay()
  const showOpenDialogOptions = () => ({
    title: 'Export',
    filters: [{ name: 'Select Folder', extensions: [''] }],
    buttonLabel: 'select',
    properties: [
      'openDirectory',
    ],
  })

  const inputVars = () => ({
    lostInvList: [],
    lostInvErrors: [],
    lostInvLoading: false,
    success: false,
    error: false,
  })

  export default {
    name: 'export-lost-inventories',
    created () {
    },
    components: {
      alertSuccess: () => import('@/views/dashboard/components/AlertSuccess'),
      alertError: () => import('@/views/dashboard/components/AlertError'),
    },
    data () {
      return {
        ...inputVars(),
      }
    },
    computed: {
      ...mapState({
        storeId: state => state.settings.storeId,
        stores: state => state.branchLocation.list,
      }),
      storeName () {
        return this.stores.find(e => e.id === this.storeId).name
      },
    },
    methods: {
      download () {
        if (this.lostInvLoading) return
        dialog.showOpenDialog(null, showOpenDialogOptions())
          .then(({ canceled, filePaths }) => {
            if (canceled) return
            this.getlostInv(filePaths[0])
          })
      },
      writeExcel (filePath) {
        return ({ data }) => {
          this.lostInvList = data
          // writeExcel(filePath, `inventory-purchases_${new Date().getTime()}`, data)
          // this.success = true
          // successDelay(() => { this.success = false })
        }
      },
      getFields () {
        return {
          'receipt no': 'receipt_no',
          'stock code': 'stock_code',
          'brand name': 'brand_name',
          description: 'description',
          'product name': 'product_name',
          'supplier id': {
            field: 'supplier_id',
            callback: value => `'${value}`,
          },
          'supplier name': 'supplier_name',
          cost: {
            field: 'cost',
            callback: value => `${value.toFixed(2)}`,
          },
          quantity: {
            field: 'quantity',
            callback: value => `${value.toFixed(2)}`,
          },
          unit: 'unit',
          'total amount': {
            field: 'total_amount',
            callback: value => `${value.toFixed(2)}`,
          },
          'date Lost': 'date_lost',
        }
      },
      async getlostInv (filePath) {
        if (this.lostInvLoading) return
        this.lostInvLoading = true
        const { storeId } = this.$store.state.settings
        try {
          const response = await lostInvRepository.storeIndexAll(storeId)
            .catch(this.getInvRcvErr)
          this.lostInvLoading = false
          return await response.data
        } catch (e) {

        }
        // .then(() => {})
        // .then(() => { this.lostInvLoading = false })
      },
      getInvRcvErr (e) {
        this.error = true
        errorDelay(() => { this.error = false })
        this.lostInvErrors = errorHandler(e)
      },
    },
  }
</script>
